<script setup>
import { UnorderedListOutlined } from '@ant-design/icons-vue';
import SolicDatatable from '~/components/SolicDatatable.vue';
</script>

<template>
  <Page menu="solic">
    <div>
      <a-row justify="center">
        <a-col :xs="24" :md="24" :lg="24" :xl="24">
          <!-- Page header -->
          <a-row>
            <a-col :span="12">
              <a-breadcrumb>
                <a-breadcrumb-item>
                  <router-link to="/solic"> Solic </router-link>
                </a-breadcrumb-item>
              </a-breadcrumb>
              <h1>
                <UnorderedListOutlined
                  style="color: #bebcbc; font-size: 18px"
                />
                Solic
              </h1>
            </a-col>
            <a-col :span="12">
              <div class="page-header-button-container" />
            </a-col>
          </a-row>
          <!-- /Page header -->
          <SolicDatatable />
        </a-col>
      </a-row>
    </div>
  </Page>
</template>
